import './index.css'
import cn from 'clsx'
import React from 'react'
import Input from 'components/ui/input'
export default class SizePicker extends React.Component<any> {
  _handleChange = e => {
    this.props.onChange({
      ...this.props.value,
      [e.target.name]: e.target.value,
    })
  }

  render() {
    const { value, readonlyHeight, minHeight, minWidth } = this.props
    const widthClassName = cn('Form_Input', {
      'SizePicker__input--error': value.width < minWidth,
    })
    const heightClassName = cn('Form_Input', {
      'SizePicker__input--error': value.height < minHeight,
    })
    return (
      <div className="SizePicker">
        <Input
          className={widthClassName}
          name="width"
          onChange={this._handleChange}
          value={value.width}
        />
        <span className="SizePicker__separator">&times;</span>
        <Input
          name="height"
          className={heightClassName}
          onChange={this._handleChange}
          value={value.height}
          readOnly={readonlyHeight}
        />
      </div>
    )
  }
}
